import {
  FORBIDDEN_ROUTES,
  PROBLEMATIC_ROUTES,
} from '../useReturnUrl.constants';

export const isForbiddenRoute = (pathname: string): boolean =>
  FORBIDDEN_ROUTES.some(
    (route) => pathname === route || pathname.startsWith(`${route}/`)
  );

export const isProblematicRoute = (url: string): boolean =>
  PROBLEMATIC_ROUTES.some((route) => url.includes(route));

export const canStoreAsReturnUrl = (pathname: string): boolean =>
  !isForbiddenRoute(pathname) && pathname !== '/';
